import { defineStore } from "pinia";

import type { User } from "../api/portal";
import { normalizeUrlOriginPath } from "../utils/urlHelpers";

// lastStatus seeds the session query (queries/session.ts) so a reload paints at once.
export const useUserPortalStore = defineStore("userPortal", {
  state: () => ({
    lastStatus: null as User | null,
    lastStatusAt: null as number | null,
    cancelledRedirects: [] as string[],
  }),

  actions: {
    markRedirectCancelled(url: string | null | undefined) {
      if (!url || typeof url !== "string") return;
      const key = normalizeUrlOriginPath(url);
      const filtered = this.cancelledRedirects.filter((entry) => entry !== key);
      filtered.unshift(key);
      this.cancelledRedirects = filtered.slice(0, 20);
    },

    isRedirectCancelled(url: string | null | undefined): boolean {
      if (!url || typeof url !== "string") return false;
      return this.cancelledRedirects.includes(normalizeUrlOriginPath(url));
    },
  },

  persist: true,
});
